// extracted by mini-css-extract-plugin
module.exports = {"slide":"slide-523edd","head":"head-523edd"};